import React from 'react';

/*
 * Task #174 — overdue-training warning banner. Shown after a WARNED login (within
 * the 7-day grace window before login is blocked). Dismissible for the session;
 * reappears on the next login until the training is recorded. Pure presentation
 * over the `trainingWarning` payload the login response carries.
 */
export default function TrainingWarningBanner({ warning, onDismiss }) {
  if (!warning) return null;
  const overdue = Array.isArray(warning.trainings) ? warning.trainings : [];
  const missing = Array.isArray(warning.missing) ? warning.missing : [];
  const days = warning.daysLeft;
  return (
    <div data-testid="training-warning-banner" role="alert" style={{
      margin: '8px 16px', padding: '10px 14px', borderRadius: 8,
      background: '#FFF7ED', border: '1px solid #FDBA74', color: '#9A3412',
      fontSize: 13, display: 'flex', alignItems: 'flex-start', gap: 10,
    }}>
      <span style={{ flex: 1 }}>
        <strong>Required compliance training is overdue.</strong>{' '}
        {typeof days === 'number'
          ? `Sign-in will be blocked in ${days} day${days === 1 ? '' : 's'}`
          : 'Sign-in may be blocked soon'}
        {overdue.length > 0 ? ` — overdue: ${overdue.map((t) => t.category).join(', ')}` : ''}
        {missing.length > 0 ? ` — not on file: ${missing.map((t) => t.category).join(', ')}` : ''}
        . Please complete your training or contact your administrator.
      </span>
      <button onClick={onDismiss} aria-label="Dismiss"
        style={{ background: 'none', border: 'none', color: '#9A3412', cursor: 'pointer', fontWeight: 700, fontSize: 16, lineHeight: 1 }}>×</button>
    </div>
  );
}
